import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';

import { LevelService } from 'src/app/_services/level.service';
import { StudentService } from 'src/app/_services/student.service';
import { SubjectService } from 'src/app/_services/subject.service';
import { SubTopicService } from 'src/app/_services/subTopic.service';
import { TopicService } from 'src/app/_services/topic.service';
import Swal from 'sweetalert2';
declare var window: any;
@Component({
  selector: 'app-free-sub-topic-worksheet',
  templateUrl: './free-sub-topic-worksheet.component.html',
  styleUrls: ['./free-sub-topic-worksheet.component.css']
})

export class FreeSubTopicWorksheetComponent implements OnInit {

  isSaving = false
  loading=false
  curriculums=[]
  levels=[]
  topics=[]
  subTopics=[]
  myForm:FormGroup
  server_level_id=0
  server_subject_id=0
  server_subtopic_id=0
  emailModal=undefined
  constructor(
    private studentService:StudentService,
    private levelService:LevelService,
    private topicService:TopicService,
    private subjectService:SubjectService,
    private router:Router,
    private subTopicService:SubTopicService) { }

  ngOnInit(): void {
    this.initMainFormFresh()
    this.loadCurriculums()
  }
  get f() {
    return this.myForm.controls
  }
  loadCurriculums() {
    this.levelService.getCurriculums().subscribe(
      {next:(data:ResultData)=>{
        this.curriculums= data.rs.data
        this.subTopics=[]
        this.topics=[]
      },error:(err)=>{console.log("error getting curriculums",err)}
    })
  }



  loadLevels(value: number) {
    this.levelService.getLevelIdAndNameByCurriculum(value).subscribe(
      {next:(data:ResultData)=>{
        this.levels = data.rs.data
       },error:(err)=>{
        console.error("Error Retrieving Level and name By Country", err)
       }

          }
        )
      }
  loadTopics(value: number) {

    this.topicService.getTopicsIdAndNameByLevelId(value).subscribe(
      x => {
        this.topics = x
         this.subjectService.getSubjectsIdAndNameByLevel(value).subscribe(
              {next:(data:ResultData)=>{
                let subjects = data.rs.data
                this.server_subject_id=subjects.length>0?subjects[0].id:0
              },error:(err)=>{
                console.error("Error retrieving subject by level",err)
              }
              }
            )
      }
    )
  }
  loadSubTopics(value: number) {

    this.subTopicService.getSubTopicIdAndNameByTopicId(value).subscribe(
      {
        next:(data:ResultData)=>{
          this.subTopics = data.rs.data
        }
      }

    )
  }
  initMainFormFresh(){
    this.myForm=new FormGroup({

      curriculum: new FormControl("", [Validators.required]),
      level: new FormControl("", [Validators.required]),
      topic: new FormControl("", [Validators.required]),
      subTopic: new FormControl("", [Validators.required])
    });
  }



  on_submit(){
    this.openEmailForm()
    this.server_subtopic_id=this.myForm.value.subTopic

    }

  openEmailForm(){
    this.emailModal = new window.bootstrap.Modal(
      document.getElementById('myEmailModal')
    );
    this.emailModal.show()
  }
  validEmailSubmission(email:string){
        this.generateOpenPdf(email)
  }
  generateOpenPdf(email:string){
    this.isSaving=true
    this.lookUpSubjectId()
    this.studentService.createFreeQuiz(this.server_subject_id,this.formatData(email)).subscribe({
      next:(data:ResultData)=>{
        this.isSaving=false
        this.alertEmailSent(email)
        this.subTopics=[]
        this.topics=[]
        this.router.navigate(['/'])
      },error:(err)=>{
        this.isSaving=false
        console.error("Error creating free quiz",err)
        Swal.fire("Error","Error creating free quiz. Please try again later",'error')
        this.router.navigate(['/'])
    }})
  }





  alertEmailSent(mail:string){
    Swal.fire("Yes","We have sent the download link. Please check your email at "+mail,'info')
  }

  formatData(email:string){
    let data = new URLSearchParams();
    this.server_level_id = this.myForm.value.level
    data.set('id', this.server_level_id.toString());
    data.set('email', email);
    data.set('sCount', '1');
    data.append('subTopics', this.server_subtopic_id.toString());
    return data.toString()
  }
  closeModal(){
    this.emailModal.hide()
  }

  lookUpSubjectId(){
    for(let t of this.topics){
      if(t.server_topic_id==this.myForm.value.topic){
        this.server_subject_id = t.server_subject_id
        break
      }
    }
  }
}
